import * as React from 'react'
import { Link } from 'react-router-dom'

import { IItem } from '../../../../typings/searchResults'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'

import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'
import Button from '../../button'

import * as styles from './featuredItemsBlock.module.css'

interface ICta {
  url: string
  title: string
}

interface IProps {
  data: IItem[]
  cta?: ICta
  title: string
  subtitle?: string
}

const FeaturedItemsBlock = ({ title, subtitle, data, cta }: IProps) => {
  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <ItemCardsLayout viewType="grid" className={styles.grid}>
          <ItemCardsLayout.CardArea className={styles.textArea}>
            <div className={styles.textAreaInner}>
              <div>
                <header>
                  <h2 className={styles.title}>{title}</h2>
                  <p className={styles.subtitle}>{subtitle}</p>
                </header>
                {cta && (
                  <Button
                    type={Button.Type.Primary}
                    className={styles.leftButton}
                    to={cta.url}
                    renderAs={Link}
                    onClick={() =>
                      reportBlockClick('Featured theme', {
                        eventLabel: cta.title
                      })
                    }
                  >
                    {cta.title}
                  </Button>
                )}
              </div>
            </div>
          </ItemCardsLayout.CardArea>

          {data.map((item, index) => (
            <ItemCardsLayout.CardArea key={item.id}>
              <ItemCard
                listName="Home page: featured items"
                item={item}
                key={item.id}
                index={index}
                viewType="grid"
              />
            </ItemCardsLayout.CardArea>
          ))}
        </ItemCardsLayout>

        {cta && (
          <Button
            type={Button.Type.Primary}
            className={styles.lowerButton}
            to={cta.url}
            renderAs={Link}
            onClick={() =>
              reportBlockClick('Featured theme', {
                eventLabel: cta.title
              })
            }
          >
            {cta.title}
          </Button>
        )}
      </div>
    </section>
  )
}

export default FeaturedItemsBlock
